'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _constants = require('../../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hook = function (_Plugin) {
  _inherits(Hook, _Plugin);
  function Hook(entity) {
    _classCallCheck(this, Hook);
    var _this = _possibleConstructorReturn(this, (Hook.__proto__ || Object.getPrototypeOf(Hook)).call(this, entity));
    _this.makeHandler = function (event) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var hooks = _this.get(event);
        _this.run.apply(_this, [hooks].concat(args));
      };
    };
    _this.hooksMap = {};
    return _this;
  }
  _createClass(Hook, [{
    key: 'get',
    value: function get(event) {
      var hooks = this.hooksMap[event] || [];
      return hooks.sort(function (_ref, _ref2) {
        var a = _ref.priority;
        var b = _ref2.priority;
        return a - b;
      }).map(function (_ref3) {
        var hook = _ref3.hook;
        return hook;
      });
    }
  }, {
    key: 'add',
    value: function add(event, hook, priority) {
      var hooks = this.hooksMap[event] || [];
      if (!hooks.length) {
        this.entity.on(event, this.makeHandler(event));
      }
      hooks.push({
        hook: hook,
        priority: priority
      });
      this.hooksMap[event] = hooks;
    }
  }, {
    key: 'run',
    value: function run(hooks) {
      var _this2 = this;
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      if (hooks.length) {
        var hook = hooks.shift();
        hook.apply(undefined, args).then(function () {
          _this2.run.apply(_this2, [hooks].concat(args));
        }).catch(function (ex) {
          _this2.entity.emit(_constants.Events.INTERNAL_ERROR, ex);
        });
      }
    }
  }]);
  return Hook;
}(_plugin2.default);
Hook.pluginName = 'hook';
exports.default = Hook;